const TYPES = {
    SHOW_ERROR_MESSAGE: 'SHOW_ERROR_MESSAGE',
    HIDE_ERROR_MESSAGE: 'HIDE_ERROR_MESSAGE'
};

export default {
    TYPES,

    showErrorMessage: (payload?) => ({
        type: TYPES.SHOW_ERROR_MESSAGE,
        payload
    }),

    hideErrorMessage: (payload?) => ({
        type: TYPES.HIDE_ERROR_MESSAGE,
        payload
    })
};
